import { render, staticRenderFns } from "./StepIncreasePower.vue?vue&type=template&id=ed67bca0&scoped=true&"
import script from "./StepIncreasePower.vue?vue&type=script&lang=js&"
export * from "./StepIncreasePower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed67bca0",
  null
  
)

export default component.exports